var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 9.33325H12.0002V7.99992H4.00016V9.33325ZM4.00016 7.33325H12.0002V5.99992H4.00016V7.33325ZM4.00016 5.33325H12.0002V3.99992H4.00016V5.33325ZM14.6668 14.6666L12.0002 11.9999H2.66683C2.30016 11.9999 1.98627 11.8694 1.72516 11.6083C1.46405 11.3471 1.3335 11.0333 1.3335 10.6666V2.66659C1.3335 2.29992 1.46405 1.98603 1.72516 1.72492C1.98627 1.46381 2.30016 1.33325 2.66683 1.33325H13.3335C13.7002 1.33325 14.0141 1.46381 14.2752 1.72492C14.5363 1.98603 14.6668 2.29992 14.6668 2.66659V14.6666ZM2.66683 10.6666H12.5668L13.3335 11.4166V2.66659H2.66683V10.6666Z",
    fill: "#BFBFBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskNotesIcon);
export default __webpack_public_path__ + "static/media/taskNotesIcon.7a094321c88b0f812357e018f82ac888.svg";
export { ForwardRef as ReactComponent };